/**
 * MI-298: why a currency has no usable rate — the client-side twin of the
 * backend's `_unconvertible_reason` (services/conversion_service.py).
 *
 * It exists because account *balances* are converted in the browser from
 * `usd_per_unit`, with no endpoint to ask. Movements get their reason from the
 * API instead; both produce the same vocabulary so the UI renders one set of
 * messages. Keep the two in step — the reason strings are the contract.
 */
export function unconvertibleReason(currency, currencyDefs = []) {
  if (!currency) return 'unknown_currency';
  const def = currencyDefs.find((c) => c.name === currency);
  // An unknown or standard currency simply has nothing in the rate table.
  if (!def || def.type === 'standard') return 'no_market_rate';
  if (!def.manual_rate || !def.manual_rate_currency) return 'custom_no_rate';
  return 'peg_unresolved';
}

/**
 * Turn `{currency: count}` tallies into the `unconvertible[]` bucket shape the
 * API returns for movements, so `UnconvertibleNote` can't tell the two apart.
 */
export function toUnconvertibleBuckets(countsByCurrency, currencyDefs = []) {
  return [...countsByCurrency.entries()]
    .sort((a, b) => String(a[0]).localeCompare(String(b[0])))
    .map(([currency, count]) => ({
      currency,
      count,
      reason: unconvertibleReason(currency, currencyDefs),
    }));
}
